export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/plus-bold-circle.2bfc5c9e.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};